import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Axios from "axios";
import { URL_LIST_ALL } from "../configs/api";
import Spinner from "./Spinner";

export default function MetaRooms(props) {
    const { defaults = [], onChange } = props
    const { user } = useSelector((state) => state.auth)
    const [listMeta, setListMeta] = useState([])
    const [metaTitle, setMetaTitle] = useState('')
    const [loading, setLoading] = useState(false)
    const [reload, setReload] = useState(false)

    useEffect(() => {
        Axios.get(URL_LIST_ALL + "rooms_meta", user.config).then((res) => {
            if (res.data.status == 'success') {
                setListMeta(res.data.data)
            }
        }).catch((err) => console.log(err));

    }, [reload]);// eslint-disable-line

    const handleChange = (e) => {
        const value = parseInt(e.target.value);
        const isChecked = e.target.checked;
        let updated = [...defaults];
        if (isChecked && !updated.includes(value)) {
            updated.push(value);
        } else if (!isChecked) {
            updated = updated.filter((id) => id !== value);
        }
        onChange?.(updated);
    };

    const addNewMeta = () => {
        if (metaTitle && metaTitle != '') {
            let values = { title: metaTitle, author_id: user.data.id, status: 1 }
            Axios.post(URL_LIST_ALL + 'rooms_meta', values, user.config).then(res => {
                setLoading(false)
                if (res.data.status == "success") {
                    setMetaTitle('')
                    setReload(!reload)
                } else {
                    alert(res.data.message)
                }
            }).catch(err => {
                setLoading(false)
            });
        }
    }

    return (<div className="w-100 outer-meta">
        <div className="input-group mb-3">
            <input type="text" className="form-control height32" placeholder="Thêm mới" value={metaTitle} onChange={(e) => setMetaTitle(e.target.value)} />
            <div className="input-group-prepend">
                <button type="button" className="btn btn-sm btn-success height32" onClick={() => addNewMeta()}>{loading ? <Spinner /> : 'Thêm'}</button>
            </div>
        </div>
        <div className="row">
            {listMeta.map((item, i) => (
                <div className="col-12 col-sm-6 form-check" key={i}>
                    <input
                        type="checkbox"
                        name="meta_id"
                        value={item.id}
                        checked={defaults.includes(item.id)}
                        onChange={handleChange}
                        className="form-check-input"
                        id={"check"+item.id}
                    />
                    <label className="form-check-label" htmlFor={"check"+item.id}>{item.title}</label>
                </div>
            ))}
        </div>
    </div>);
}
